import { useMemo } from 'react';

import type { CalculationData, Line } from '~/api/common/types';

import { useTable } from '~/components';
import { ColumnIds } from '~/constants/table';

import type { DocumentLineRow } from './DocumentLinesTable.hooks';

import { useDocumentLinesTableColumns } from './DocumentLinesTable.hooks';

type Props = {
  calculationData: CalculationData;
  lines: Line[];
};

export const DocumentLinesTable = ({ calculationData, lines }: Props) => {
  const data = useMemo<DocumentLineRow[]>(() => lines.map((line, index) => ({ id: index, line })), [lines]);
  const hasDiscount = useMemo(() => lines.some((line) => line.type === 'entry' && line.discountType !== null), [lines]);

  const columns = useDocumentLinesTableColumns({ calculationData });
  const [table, Table] = useTable({
    data,
    columns,
    manualPagination: true, // Show all rows
    state: { columnVisibility: { [ColumnIds.documentLinesDiscount]: hasDiscount } },
  });

  return (
    <Table.Root table={table}>
      <Table.Grid>
        <Table.Header />

        <Table.Body>{(row) => <Table.Row row={row} />}</Table.Body>
      </Table.Grid>
    </Table.Root>
  );
};
